import { useState } from "react";
import { Link } from "react-router-dom";
import { CaretLeft, PlugsConnected, ChartBar, Database } from "@phosphor-icons/react";
import { SectionCards } from "../components/SectionCards";
import { WebappDataSection } from "../components/WebappDataSection";
import { EcosystemDbStatus } from "../components/EcosystemDbStatus";
import WebAppPage from "./WebAppPage";

const SECTIONS = [
  { id: "collegamenti", title: "Monitoraggio collegamenti", icon: PlugsConnected, color: "#38BDF8", desc: "Salute dei collegamenti: Doctor, ping e diagnostica delle webapp", testId: "monitorapp-section-collegamenti" },
  { id: "dati", title: "Monitoraggio dati", icon: ChartBar, color: "#34D399", desc: "KPI e andamenti raccolti dalle webapp + grafici incrociati", testId: "monitorapp-section-dati" },
  { id: "db", title: "Monitoraggio database", icon: Database, color: "#C084FC", desc: "Salute, latenza e storico rallentamenti dei database", testId: "monitorapp-section-db" },
];

export default function MonitorAppPage() {
  const [section, setSection] = useState(null);

  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="monitor-app-page">
      <div className="mb-8 animate-fade-up">
        <Link to="/monitor" data-testid="monitor-app-back" className="inline-flex items-center gap-1 text-xs text-white/50 hover:text-white transition-colors mb-3">
          <CaretLeft size={12} /> Monitor
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2">Monitor</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none">APP</h1>
        <p className="text-sm text-slate-400 mt-3">Clicca una card per aprire la sezione corrispondente.</p>
      </div>

      <SectionCards sections={SECTIONS} active={section}
        onSelect={(s) => setSection(section === s.id ? null : s.id)} gridClass="grid-cols-1 md:grid-cols-3" />

      {section === "collegamenti" && <WebAppPage />}
      {section === "dati" && <WebappDataSection />}
      {section === "db" && <EcosystemDbStatus />}
    </main>
  );
}
